export default {"src":"/_next/static/media/Copy.ddcd9846.svg","height":14,"width":13,"blurWidth":0,"blurHeight":0};